import { Component, EventEmitter, Inject, Input, Optional, Output } from '@angular/core';
import { GridModalComponent } from '../../../core/components/grid/grid.decorators';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridToolbarButton, GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';
import { TT_STATE_DIALOG, StateDialogContext } from '../../../modal/state-modal/state-modal.component';

@GridModalComponent('dodataimpswizardedit')
@Component({
    selector: 'tt-do-data-imps-wizard-edit',
    templateUrl: './do-data-imps-wizard-edit.component.html',
    styleUrls: ['./do-data-imps-wizard-edit.component.css'],
})
export class DoDataImpsWizardEditComponent {
    @Input()
    public params?: BspWizardItem;
    public get?: BspWizardItem;

    @Output()
    public submit = new EventEmitter<string>();

    public grid?: GridOptions;

    constructor(
        private datatask: DataTaskService,
        @Inject(TT_STATE_DIALOG) @Optional() stateDialog: StateDialogContext,
    ) {
        this.initFromDialog(stateDialog);
    }

    private async init() {
        this.get = (await this.datatask.Post(3889, this.params))[0];
        //const response = await this.datatask.Post(3889, this.params);

        //for (let i = 0; response[0].length > i; i++) {
        //    if (response[i]['bsp_wizard_keyno'] === this.params!.bsp_wizard_keyno) {
        //        this.get = response[i];
        //        break;
        //    }
        //}

        //if (!this.get) this.get = response[0];

        this.params!.bsp_wizard_name = this.get?.bsp_wizard_name ?? '';
        this.createGrid();
        //console.log('response');
        //console.dir(response);
        //console.dir(this.get);
        //console.dir(this.params);
    }

    private createGrid() {
        if (!!this.get) {
            this.grid = new Grid()
                .setRememberId('tt-do-data-imps-wizard-edit.grid')
                .setLoadDataFunction({ method: 3881, parameters: () => this.get })
                .setCustomToolbarButtons([this.saveWizard(), this.deleteWizard()]);
        }
    }

    private saveWizard(): GridToolbarButton {
        return {
            name: 'save_wizard',
            text: 'save_wizard',
            translate: true,
            func: async () => {
                const selectedRows = this.grid?.gridfunc?.getIsSelectedRows(false, true, true);
                this.get!.bsp_wizard_name = this.params?.bsp_wizard_name ?? '';

                if (selectedRows && selectedRows.length > 0) {
                    const response = await this.datatask.Post(3892, { head: this.get, isSelected: selectedRows, delete: false });

                    if (!response?.validation) {
                        this.submit.emit(this.get?.bsp_wizard_keyno);
                    }
                }
            },
            icon: 'far fa-save',
            cssClass: 'tt-button tt-button--success im-grid-btn-xs-l',
        };
    }

    private deleteWizard(): GridToolbarButton {
        return {
            name: 'delete_wizard',
            text: 'delete_wizard',
            translate: true,
            func: async () => {
                const response = await this.datatask.Post(3892, { head: this.get, isSelected: [], delete: true });

                if (!response?.validation) {
                    this.submit.emit(this.get?.bsp_wizard_keyno);
                }
            },
            disabled: () => {
                if (this.get?.bsp_wizard_keyno === '0') return 'hidden';
                else return false;
            },
            icon: 'far fa-trash',
            cssClass: 'tt-button tt-button--danger im-grid-btn-xs-r',
        };
    }

    private async initFromDialog(stateDialog?: StateDialogContext) {
        if (!!stateDialog?.params && 'bsp_wizard_keyno' in stateDialog.params) {
            this.params = stateDialog.params as unknown as BspWizardItem;
            stateDialog.setSize({ height: '80vh', width: '80vw' });
            await this.init();
            stateDialog.setHeading(this.get?.bsp_wizard_edit_heading ?? '');
            this.submit.subscribe({ next: (value: string) => stateDialog.close(value) });
        }
    }
}

interface BspWizardItem {
    bsp_keyno: string;
    bsp_wizard_keyno: string;
    bsp_wizard_name: string;
    word_id: string;
    bsp_wizard_edit_heading: string;
}
